import Mammoth from 'mammoth';

export const getWordFileContent = async (file) => {
  let wordContent = '';
  if (file && file.name.endsWith('.docx')) {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onload = async (event) => {
        const arrayBuffer = event.target.result;
        try {
          const result = await Mammoth.extractRawText({ arrayBuffer });
          wordContent = result.value;
          resolve(wordContent);
        } catch (error) {
          reject(error);
        }
      };
      reader.readAsArrayBuffer(file);
    });
  }
  return wordContent;
};



// WEBPACK FOOTER //
// ./src/utils/fileUtils.js